<template>
    <div>
        <v-autocomplete
            v-model="bank"
            :items="bankStore.banksSelect"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import {useBankStore} from "@/stores/Bank";
import axios from "axios";

export default {
    name: "StrBankAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        label: String,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const bankStore = useBankStore();

        const bank = ref(null);

        function findAll() {
            loading.value  = true;
            axios.get(`/banks`).then(response => {
                bankStore.setBanksSelect(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            bank.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            bankStore,
            loading,
            inputColor,
            backgroundColor,
            bank,
            input,
        }
    }
}
</script>

<style scoped>

</style>